const trackEvents = {
  init() {
  this.trackSearchClick();
  this.trackClicksInAHeaderMenu();
  },

  trackSearchClick() {
    if (window.location.pathname.includes('/search')) {
      const urlParams = new URLSearchParams(window.location.search);
      const searchTerm = urlParams.get('q') || '';
      document.addEventListener('click', function (e) {
        const link = e.target.closest('a');
        // Remove or adjust this condition based on actual DOM
        if (link && link.href.includes('/products/')) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'search_result_click',
            content_type: 'search result item',
            search_term: searchTerm,
            clicked_url: link.href
          });
        }
      });
    } 
  },

  trackClicksInAHeaderMenu() {
    document.querySelector(".header__icons").addEventListener('click', (event) => {
      try{
        let closestSpanOrAnchor  = event.target.closest('span, a');
        if (closestSpanOrAnchor?.tagName.toLowerCase() == 'a') {
          const takeFirstSpan = closestSpanOrAnchor.querySelector('span');
          closestSpanOrAnchor = takeFirstSpan.textContent.trim();
        } else {
          closestSpanOrAnchor = closestSpanOrAnchor.textContent.trim();
        }
        const linkPresent = event.target.closest('a');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event:'select_content',
          content_type:'menu',
          menu_name: 'Header Icons',
          link_text: closestSpanOrAnchor,
          link_url: linkPresent ? linkPresent.href : ''
        });
      } catch(err) {
        console.log(err);
      }
    })
  }
};

document.addEventListener('DOMContentLoaded', () => {
    trackEvents.init();
});